import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { policy } from 'src/@order/commonData/policy';
import { terms } from 'src/@order/commonData/terms';

@Component({
  selector: 'app-info-dialog2',
  templateUrl: './info-dialog2.component.html',
  styleUrls: ['./info-dialog2.component.scss'],
})
export class InfoDialog2Component implements OnInit {
  heading: string;
  infoMessage: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<InfoDialog2Component>,
    private sanitized: DomSanitizer
  ) {
    // get data
    this.heading = this._data.heading;
    // this.infoMessage = _data?.type == 'html' ? this.transform(this._data.message) : this._data.message;
    if (_data?.type == 'terms') {
      this.infoMessage = this.transform(terms);
    } else if (_data?.type == 'policy') {
      this.infoMessage = this.transform(policy);
    } else {
      this.infoMessage = this._data.message;
    }
  }

  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }

  ngOnInit(): void {}
}
